// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';

import ReactPhoneInput from '../../components/reactPhoneInput';

class SimplePhoneInput extends Component {

  static defaultProps = {
    value: '',

    placeholder: '6 00 00 00 00',

    disabled: false,

    readOnly: false,

    error: false,
  };

  static propTypes = {
    value: PropTypes.string,

    placeholder: PropTypes.string,

    /**
     * @param number The phone number
     */
    onChange: PropTypes.func.isRequired,

    disabled: PropTypes.bool,

    readOnly: PropTypes.bool,

    error: PropTypes.bool,
  };

  shouldComponentUpdate(nextProps: Object) {
    return this.props.value !== nextProps.value ||
            this.props.error !== nextProps.error;
  }

  // -- events

  onNumberChange = (value) => {
    // delete spaces
    if (_.isNull(value) || _.isNull(this.props.value)
    || value.replace(/ /g, '') !== this.props.value.replace(/ /g, '')) {
      this.props.onChange(value.replace(/ /g, ''));
    }
  };


  // -- renderers

  render() {
    const number = this.props.value;
    const className = classNames('phone_input', {
      error: this.props.error,
    });

    return (
      <div className={className}>
        <ReactPhoneInput
          defaultCountry={'fr'}
          value={number}
          onChange={this.onNumberChange}
          placeholder={this.props.placeholder}
          disabled={this.props.disabled || this.props.readOnly}
        />
      </div>
    );
  }

}

export default SimplePhoneInput;



// WEBPACK FOOTER //
// ./sdk/scripts/components/form/SimplePhoneInput.js